<div class="container pre">
  <mat-card>
    <mat-card-title>
      <h1>Thank You <span class="p">{{user.name}}!!</span> for chosing us. </h1>
    </mat-card-title>
    <mat-card-content>
      <h3>Based On Your given data, We have to inform you that you are
        <u class="p">{{prediction}}</u> from the heart disease.
      </h3>
    </mat-card-content>
    <mat-card-footer class="gap">
      <button class="m-2" type="button" mat-raised-button (click)="back()">Go back</button>
      <button type="button" mat-raised-button (click)="toggle()">{{buttonName}}</button>
    </mat-card-footer>
  </mat-card>

  <mat-card class="m-3" *ngIf="show">
    <mat-card-header>
      <h2>FeedBack Form! How can we more beneficial for you?</h2>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="feedbackForm" (ngSubmit)="submit()">
        <mat-card-title>Your opinion matters!</mat-card-title>
        <hr>
        <mat-form-field>
          <mat-label>Leave your feedback</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field><br/>
        <mat-form-field>
          <mat-label>Satisfaction Level </mat-label>
          <mat-select formControlName="satisfaction">
            <mat-option  *ngFor="let g of gen" [value]="g">
              {{g}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="feedbackForm.get('satisfaction').errors">
            This field is <strong>required</strong>
          </mat-error>
        </mat-form-field><br/>
        <hr>
        <button type="submit" [disabled]="!feedbackForm.valid" mat-raised-button> Submit</button>
        <button type="reset" class="ml-2" mat-raised-button> Reset</button>
      </form>
    </mat-card-content>
  </mat-card>

</div>
